/**
 * Security utilities for host blocking and validation
 */

import config from '@/config/security.config';

/**
 * Check if the current host is blocked
 * @returns {boolean} True if the host is blocked
 */
export function isHostBlocked() {
  if (!config.enabled) {
    return false;
  }

  const currentHost = window.location.hostname;
  return config.blockedDomains.some(pattern => pattern.test(currentHost));
}

/**
 * Get the current hostname
 * @returns {string} The current hostname
 */
export function getCurrentHost() {
  return window.location.hostname;
}

/**
 * Block access and show error message
 * This function replaces the entire page content with an error message
 */
export function blockAccess() {
  const currentHost = getCurrentHost();

  // Log the blocked attempt if enabled
  if (config.logBlockedAttempts) {
    console.warn(`Access blocked from host: ${currentHost}`);
  }

  // Replace the entire page content with an error message
  document.body.innerHTML = `
    <div style="
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      font-family: Arial, sans-serif;
      background-color: #f5f5f5;
    ">
      <div style="
        text-align: center;
        padding: 2rem;
        background: white;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        max-width: 400px;
      ">
        <h1 style="color: #e74c3c; margin-bottom: 1rem;">Access Denied</h1>
        <p style="color: #666; line-height: 1.5;">
          ${config.errorMessage}
        </p>
        <p style="color: #999; font-size: 0.9rem; margin-top: 1rem;">
          Host: ${currentHost}
        </p>
      </div>
    </div>
  `;
  
  // Prevent further execution
  throw new Error('Access blocked from this domain');
}

/**
 * Initialize host blocking check
 * Call this function early in your application lifecycle
 */
export function initializeHostBlocking() {
  if (isHostBlocked()) {
    blockAccess();
  }
}
